export const idDev = process.env.NODE_ENV === "development"; 

export const searchProductsByQuery = '/api/v3/discover'

export const searchProductsById = '/api/v3/discover/recommendation'

export const searchCombinationByIds = "/api/v1/board/combination-products";